// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zone_equipes[data-v-0f62ed7a],.zone_sans_equipe[data-v-0f62ed7a]{overflow-y:auto;max-height:calc(100vh - 190px)}", ""]);
// Exports
module.exports = exports;
